
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { RainfallRow } from '../../model';

@Component
export default class RainfallTable extends Vue {
  @Prop({ required: true })
  data!: RainfallRow[];

  get damsHeaders(): string[] {
    const firstRow = (this.data as RainfallRow[] | undefined)?.[0];
    if (firstRow) {
      return firstRow.dams.map((dam) => dam.label);
    }
    return [];
  }
}
